import { render } from "./EmployeeDetailsPageWorkAreas.vue?vue&type=template&id=691c760a"
import script from "./EmployeeDetailsPageWorkAreas.vue?vue&type=script&lang=ts"
export * from "./EmployeeDetailsPageWorkAreas.vue?vue&type=script&lang=ts"
script.render = render

export default script